/* Copyright (c) 2023 Xperi. All Rights Reserved. */

import { IErrorBase } from './IErrorBase';

export class AppError implements IErrorBase {
    protected code: string;

    protected message: string;

    protected description: string = '';

    protected type: string = '';

    public getType(): string {
        return this.type;
    }

    constructor(code: string, message?: string) {
        this.code = code;
        this.message = message!;
    }

    getDescription(): string {
        return this.description;
    }

    setDescription(description: string) {
        this.description = description;
    }

    getCode() {
        return this.code;
    }

    getMessage() {
        return this.message;
    }
}
